// Fixes a Parcel bug with await/async polyfilling: https://github.com/parcel-bundler/parcel/issues/1762#issuecomment-504389468
import 'regenerator-runtime/runtime';

import AppApi from './AppApi';

// These exports are the public interface of asmag-app-lib. These are
// the only objects in asmag-app-lib that can be used directly by the
// Asteikko Mag app implementations (e.g. web app, iOS app, etc.).
//
// Use the lib like this:
// `import appLib from 'asmag-app-lib`
//
// Or alternatively, use the window.AsteikkoAppLib global, which is exposed in
// the global namespace in case some other WP plugin wants to implement
// a customer-specific Asteikko Mag frontend app.

const appLib = window.AsteikkoAppLib = {
  AppApi
};

export default appLib;
